import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

const InitializeSentry = (): void => {
  Sentry.init({
    dsn: 'https://7bd0148bb69f4a6fab2f520563acfc47@o538483.ingest.sentry.io/6329123',
    ignoreErrors: [
      "undefined is not an object (evaluating 'n.length')",
      'Request failed with status code 500',
    ],
    integrations: [new BrowserTracing()],
    normalizeDepth: 20,
    tracesSampleRate: 1.0,
  });
};

export default InitializeSentry;
